import { ComponentPropsWithoutRef } from 'react';

export const ArrowRight = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      stroke="currentColor"
      d="M14.57 18.0699L20.5 11.9999M20.5 11.9999L14.57 5.92995M20.5 11.9999H3.67001"
    />
  </svg>
);
